// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"83654e42","453":"b1c6d853","618":"fba1a092","707":"5acf7283","717":"75ae6e07","748":"7d91b288","952":"9b0a80b0"}[chunkId] + ".chunk.js";
};